import React from "react";
import { useAdminStatus } from "@/hooks/useAdminStatus";

export const AuthCheck = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAdminStatus();
  
  // Only render children if user is authenticated
  // Otherwise, render nothing but still allow other content on the page to show
  return <>{user ? children : null}</>;
};
